
import { useState, useEffect } from 'react';

export default function AboutHero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center px-8 pt-20">
      <div className="absolute inset-8 rounded-[40px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/8fd05a8220ed3ea8bafa87a063a136d3.jpg"
          alt="TechVision Headquarters"
          className={`w-full h-full object-cover object-top transition-transform duration-[2000ms] ease-out ${loaded ? 'scale-100' : 'scale-110'}`}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto w-full">
        <div
          className={`inline-flex items-center px-5 py-2 rounded-full border border-white/30 backdrop-blur-sm mb-8 transition-all duration-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="text-white text-sm font-medium whitespace-nowrap">Established 2009</span>
        </div>

        <h1
          className={`text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight transition-all duration-700 delay-200 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          We Build the Future<br />of Enterprise Tech
        </h1>

        <p
          className={`text-lg md:text-xl text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed transition-all duration-700 delay-[400ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          A global technology consulting firm helping businesses navigate digital transformation with innovation, integrity, and measurable impact.
        </p>

        <div
          className={`flex items-center justify-center gap-8 transition-all duration-700 delay-[600ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="text-center">
            <div className="text-3xl font-bold text-white">15+</div>
            <div className="text-sm text-white/70">Years</div>
          </div>
          <div className="w-px h-10 bg-white/30"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">500+</div>
            <div className="text-sm text-white/70">Projects</div>
          </div>
          <div className="w-px h-10 bg-white/30"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">200+</div>
            <div className="text-sm text-white/70">Clients</div>
          </div>
          <div className="w-px h-10 bg-white/30"></div>
          <div className="text-center">
            <div className="text-3xl font-bold text-white">98%</div>
            <div className="text-sm text-white/70">Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
